// src/app/services/pdf-annotation-state.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { PdfAnnotation } from '../models';

@Injectable({ providedIn: 'root' })
export class PdfAnnotationStateService {
  public annotations$ = new BehaviorSubject<PdfAnnotation[]>([]);
  public componentToHighlight$ = new BehaviorSubject<string | null>(null);
  public componentToSelect$ = new BehaviorSubject<string | null>(null);

  loadAnnotations(annotations: PdfAnnotation[]): void {
    this.annotations$.next(annotations);
  }

  // Called from table/graph to highlight in PDF
  highlightComponentInPdf(designator: string | null): void {
    this.componentToHighlight$.next(designator);
  }

  // Called from PDF to select in table/graph
  selectComponentFromPdf(designator: string | null): void {
    this.componentToSelect$.next(designator);
  }
}

